export const version = "wallet/5.0.2";
//# sourceMappingURL=_version.js.map